var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkspacePanel',{attrs:{"win":_vm.win},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t("AdvancePayment")))]},proxy:true}])},[_c('AdvancePaymentTab',{attrs:{"win":_vm.win}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }